function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#send-email_svg__clip-send)",
  stroke: "#333",
  strokeWidth: 1.25
}, /*#__PURE__*/React.createElement("path", {
  d: "M13.313 29.28l9.548 9.55a.5.5 0 00.754-.055L45.12 10.043a.5.5 0 00-.504-.79L3.152 18.028a.5.5 0 00-.25.843l8.198 8.198",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M44.289 9.92L13.313 29.28M44.289 9.92L11.1 27.069",
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.1 27.068l.696 11.616 1.517-9.403",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.796 38.684l4.062-3.595 1.015-.899.508-.45"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "send-email_svg__clip-send"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 48V0h48v48H0z",
  fill: "#fff"
})));

function SvgSendEmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCA0OCA0OCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAtc2VuZCkiPgo8cGF0aCBkPSJNMTMuMzEyOSAyOS4yODA3TDIyLjg2MTQgMzguODI5MkMyMy4wNzY3IDM5LjA0NDUgMjMuNDMyOCAzOS4wMTkxIDIzLjYxNTIgMzguNzc1M0w0NS4xMjAyIDEwLjA0MjZDNDUuMzk2NyA5LjY3MzIxIDQ1LjA2NzkgOS4xNTgzNCA0NC42MTY0IDkuMjUzODZMMy4xNTE5OSAxOC4wMjdDMi43NjM3NSAxOC4xMDkyIDIuNjIxMzQgMTguNTg5MSAyLjkwMTk0IDE4Ljg2OThMMTEuMTAwMyAyNy4wNjgxIiBzdHJva2U9IiMzMzMzMzMiIHN0cm9rZS13aWR0aD0iMS4yNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik00NC4yODg4IDkuOTIwOUwxMy4zMTI5IDI5LjI4MDgiIHN0cm9rZT0iIzMzMzMzMyIgc3Ryb2tlLXdpZHRoPSIxLjI1IiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KPHBhdGggZD0iTTQ0LjI4ODggOS45MjA5TDExLjEwMDMgMjcuMDY4MyIgc3Ryb2tlPSIjMzMzMzMzIiBzdHJva2Utd2lkdGg9IjEuMjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgo8cGF0aCBkPSJNMTEuMTAwMyAyNy4wNjgyTDExLjc5NjEgMzguNjg0M0wxMy4zMTI5IDI5LjI4MDgiIHN0cm9rZT0iIzMzMzMzMyIgc3Ryb2tlLXdpZHRoPSIxLjI1IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTExLjc5NjEgMzguNjg0M0wxNS44NTc3IDM1LjA4ODlMMTYuODczMSAzNC4xOUwxNy4zODA4IDMzLjc0MDYiIHN0cm9rZT0iIzMzMzMzMyIgc3Ryb2tlLXdpZHRoPSIxLjI1Ii8+CjwvZz4KPGRlZnM+CjxjbGlwUGF0aCBpZD0iY2xpcC1zZW5kIj4KPHBhdGggZD0iTTAgNDhMLTIuMDk4MTVlLTA2IDBMNDggLTIuMDk4MTVlLTA2TDQ4IDQ4TDAgNDhaIiBmaWxsPSJ3aGl0ZSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPgo=";
export { SvgSendEmail as ReactComponent };